export default function getDefaultState () {
  return { clients: {}, loading: false, editingLoading: {}, error: false }
}
